import {getDataWithPromise, Globals, handleAjaxError} from "./BaseDataFns";

export const getSectionsForYear = ( provider_id, survey_id, year, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id +'/survey/' + survey_id + '/sections/' + year ;

    getDataWithPromise ( url, 'GET', {} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const submitSurvey = ( provider_id, year, survey_type, formData, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id +'/surveys/' + year ;

    const data = {
        operation: 'submit',
        summary_text: formData.comment,
        survey_type: survey_type
    }

    getDataWithPromise ( url, 'PUT', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const reopenSurvey = ( provider_id, year, survey_type, is_adhoc,  onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id +'/surveys/' + year ;

    const data = {
        operation: 'reopen',
        survey_type: survey_type,
        is_adhoc: is_adhoc
    }

    getDataWithPromise ( url, 'PUT', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getSectionQuestions = ( provider_id, enc_provider_section_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/sections/' + enc_provider_section_id + '/questions' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getSectionDetails = ( section_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/ref/sections/' + section_id ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getProviderResponses = ( provider_id, academic_year, survey_type, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/' + academic_year + '/responses?survey_type=' + survey_type ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getProviderResponsesById = ( provider_id, provider_table_instance_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/surveysbyid/' + provider_table_instance_id + '/responses' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateQuestion = ( provider_id, enc_provider_section_id, provider_table_response_id, form_data, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/sections/' + enc_provider_section_id + '/questions/' + provider_table_response_id ;

    getDataWithPromise ( url, 'PUT', form_data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}


